import { ref } from 'vue'

/**
 * Show the Install modal
 *
 * src/components/Vue/InstallModal.vue
 */
export const showInstallModalStore = ref<boolean>(false)
